import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import styles from './RangeSlider.module.scss';
// TODO: Implement range slider filter component
// - Add min/max range input
// - Handle range selection
// - Show current range values
// - Add step support
// - Add accessibility features
export function RangeSlider({ min, max, gap, currentMin, currentMax, onChange }) {
    const [displayValues, setDisplayValues] = useState({
        min: currentMin,
        max: currentMax,
    });
    useEffect(() => {
        setDisplayValues({
            min: currentMin,
            max: currentMax,
        });
    }, [currentMin, currentMax]);
    const handleInput = (index) => (e) => {
        const newValue = parseInt(e.target.value, 10);
        const newValues = index === 0
            ? [newValue, displayValues.max]
            : [displayValues.min, newValue];
        setDisplayValues({
            min: newValues[0],
            max: newValues[1],
        });
    };
    const handleChange = (index) => (e) => {
        const newValue = parseInt(e.target.value, 10);
        const newValues = index === 0
            ? [newValue, displayValues.max]
            : [displayValues.min, newValue];
        onChange(newValues);
    };
    return (h("div", { class: styles.rangeSlider },
        h("div", { class: styles.display },
            h("span", null,
                "$",
                displayValues.min),
            h("span", null,
                "$",
                displayValues.max)),
        h("div", { class: styles.inputs },
            h("input", { type: "range", min: min, max: max, step: gap, value: displayValues.min, onInput: handleInput(0), onChange: handleChange(0), class: `${styles.input} ${styles.inputMin}` }),
            h("input", { type: "range", min: min, max: max, step: gap, value: displayValues.max, onInput: handleInput(1), onChange: handleChange(1), class: `${styles.input} ${styles.inputMax}` }))));
}
